<template>
  <div class="d-flex justify-space-between align-center">
    <div style="font-size:16px; min-width:50px; " class="text-left">{{left_value}}</div>
    <div class="flex-grow-1 d-flex flex-row align-center pl-5 pr-5">
      <div class="flex-grow-1 low-dash">&nbsp;&nbsp;</div>
      <span>&nbsp;</span>
    </div>
    <div style="min-width:150px;"  class="text-right pa-2">
      <b>{{right_value}}</b>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashedFact",
  props: {
    left_value: {
      type: String,
      default: false,
    },
    right_value: {
      type: String,
      default: false,
    },
  },
};
</script>

<style scoped>
.low-dash {
  border-bottom: 1px dashed #ccc;
}
</style>